import { render } from "./Mountains.vue?vue&type=template&id=b8e391b8&scoped=true"
import script from "./Mountains.vue?vue&type=script&lang=js"
export * from "./Mountains.vue?vue&type=script&lang=js"

import "./Mountains.vue?vue&type=style&index=0&id=b8e391b8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e391b8"]])

export default __exports__